import { render, staticRenderFns } from "./StatusLeilaoSelector.vue?vue&type=template&id=770c2f22&scoped=true&"
import script from "./StatusLeilaoSelector.vue?vue&type=script&lang=js&"
export * from "./StatusLeilaoSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c2f22",
  null
  
)

export default component.exports